import { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { zodResolver } from '@hookform/resolvers/zod';
import { ESTATUS } from '../../../../catalogs/status';
import { useForm, Controller } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { MODE } from '../../../../interaces/mode.interface';
import { regexApi } from '../../api/regex.api';
import ConfirmationMessage from '../../../../components/GenericComponents/ConfirmationMessage';
import BoxConfirmation from '../../../../components/GenericComponents/BoxConfirmation';
import { justNumbersAndLetters, justLetters } from '../../../../services/helpers';
import {
  TOAST_ERROR_IDS,
  TOAST_INFO_IDS,
  TOAST_SUCCESS_IDS,
} from '../../../../interaces/toast.ids.interface';
import { streamData } from '../../../../services/helpers';
import Select from 'react-select';
import { regexSchema } from '../../schemas/regex.schema';
function ModalRegex({ onClose, nextOnSaved = () => {}, model = null, mode = MODE.CREATE }) {
  const {
    register,
    watch,
    handleSubmit,
    control,
    formState: { errors, isDirty },
    reset,
    getValues,
    trigger,
  } = useForm({
    resolver: zodResolver(regexSchema),
  });
  const [openModalConfirmation, setOPenModalConfirmation] = useState(false);
  const [confirmDisableDependency, setConfirmDisableDependency] = useState(false);
  const [data, setData] = useState(null);
  const [deleteInfo, setDeleteInfo] = useState();
  const [loading, setLoading] = useState(false);
  const [modelName, setDependencyName] = useState('');
  const [saveRegex, setSaveRegex] = useState(true);
  useEffect(() => {
    if (mode === MODE.UPDATE) {
      reset({
        name: model.rfc || '',
        description: model.nombre || '',
        regex: model.organismo || '',
      });
      setRegexWrite(model.organismo || '');
    } else {
      reset({
        name: '',
        description: '',
        regex: '',
      });
      setRegexWrite('');
    }
    setRegexOk(false);
    setMessageRegex(null);
  }, [model, mode, reset]);

  const onSubmit = async (formData) => {
    // Misma fuente de verdad que validateRegex: regexWrite,
    // nunca el valor que pasó por el resolver de zod.
    const data = { ...formData, regex: regexWrite };
    setData(data);
    setLoading(true);
    try {
      streamData(data);
      if (mode === MODE.CREATE) {
        const response = await regexApi.create(data);
        nextOnSaved(response);
      } else {
        if (
          model.name === data.name &&
          model.description === data.description &&
          model.regex === data.regex
        ) {
          toast(TOAST_INFO_IDS.NO_DATA_TO_UPDATE, {
            icon: 'ℹ️',
            id: TOAST_INFO_IDS.NO_DATA_TO_UPDATE,
          });
          setLoading(false);
          return;
        }
        await regexApi.update(model.id, data);
      }
      toast.success(
        mode === MODE.CREATE
          ? TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY
          : TOAST_SUCCESS_IDS.RECORD_UPDATED_SUCCESSFULLY,
        { id: TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY }
      );

      onClose();
    } catch (error) {
      toast.error(
        (error.message && error.message !== 'Error'
          ? error.message
          : TOAST_ERROR_IDS.ERROR_PERFORMING_THIS_ACTION) ||
          TOAST_ERROR_IDS.ERROR_PERFORMING_THIS_ACTION,
        { id: TOAST_ERROR_IDS.TWO }
      );
    } finally {
      setLoading(false);
    }
  };

  const onDisableDependency = async () => {
    setConfirmDisableDependency(true);
  };

  const [whereChanges, setWhereChanges] = useState(false);
  useEffect(() => {
    setWhereChanges(isDirty);
  }, [isDirty]);

  const [regexOk, setRegexOk] = useState(false);

  const [messageRegex, setMessageRegex] = useState(null);
  const [regexWrite, setRegexWrite] = useState(null);
  const validateRegex = async (data) => {

    const isValid = await trigger();
    if (!isValid) {
      return;
    }
    try {
      // const a='^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,5}$'
      // console.log(a)
      // console.log(String(regexWrite))
      data.regex=String(regexWrite)


   
      const response = await regexApi.validate(data);
      setRegexOk(response.validRegex);
      setMessageRegex(response.message);
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
    // finally{

    // }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content max-h-[85vh] w-[800px] max-w-[92%]">
        <div className="modal-header">
          <h2 className="font-bold ">{model ? 'Editar regex' : 'Nuevo regex'}</h2>
          <button type="button" onClick={onClose} className="modal-close-btn">
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          {regexOk && (
            <p className="mb-5 text-center text-lg text-green-500 font-bold">
              {messageRegex || '¡Regex validado correctamento!'}
            </p>
          )}
          {!regexOk && (
            <>
              <p className="mb-5 text-center text-lg text-red-500 ">{messageRegex}</p>
            </>
          )}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              <div className="flex flex-col">
                <label className="label-base">
                  Nombre<p className="text-red-500">*</p>
                </label>
                <input
                  type="text"
                  maxLength={50}
                  {...register('name', {
                    onChange: (e) => {
                      justLetters(e, false);
                    },
                  })}
                  placeholder="Ej:Validador de cadenas email"
                  className="input-base"
                />
                {errors.name && <span className="error-text">{errors.name.message}</span>}
              </div>
              <div className="flex flex-col">
                <label className="label-base">Descripción</label>
                <input
                  disabled={mode === MODE.UPDATE}
                  type="text"

                  {...register('description', {})}
                  placeholder="Escribe la descripción breve del regex"
                  className="input-base"
                />
                {errors.description && (
                  <span className="error-text">{errors.description.message}</span>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 gap-5 ">
              <div className="flex flex-col mt-3">
                <label className="label-base">
                  regex<p className="text-red-500">*</p>
                </label>
                <input
                  {...register('regex', {
                    onChange: (e) => setRegexWrite(e.target.value),
                  })}
                  className="input-base"
                />
                {errors.regex && <span className="error-text">{errors.regex.message}</span>}
              </div>
            </div>
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              <div className="flex flex-col">
                <label className="label-base">
                  Cadena a probar<p className="text-red-500">*</p>
                </label>
                <input
                  disabled={mode === MODE.UPDATE}
                  type="text"
                  {...register('inputToTest', {})}
                  placeholder="Ej:myemail@gmail.com"
                  className="input-base"
                />
                {errors.inputToTest && (
                  <span className="error-text">{errors.inputToTest.message}</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 gap-5 ">
              <di>
                <label
                  className="
                      mt-5
                      flex
                      cursor-pointer
                      items-center
                      gap-3
                      text-sm
                      text-slate-700
                    "
                >
                  <input
                    type="checkbox"
                    className="
                        h-4
                        w-4
                        rounded
                        border-slate-300
                        text-primary
                        focus:ring-primary
                      "
                    checked={saveRegex}
                    onChange={(e) => setSaveRegex(e.target.checked)}
                  />

                  <span>Guardar para futuras ocasiones</span>
                </label>
              </di>
            </div>

            <div className="modal-footer">
              <button type="button" onClick={onClose} className="btn-cancel">
                Cancelar
              </button>
              <button
                type="button"
                onClick={() => {
                  const data = getValues();
                  validateRegex(data);
                  regexSchema.safeParse(data);
                }}
                className="
                        w-full
                        rounded-lg
                        bg-green-500
                        px-4
                        py-2.5
                        text-sm
                        font-semibold
                        text-white
                        transition
                        hover:bg-green-600
                        sm:w-auto
                      "
              >
                Validar regex
              </button>
              {saveRegex && (
                <button
                  type="submit"
                  disabled={loading === true || (!whereChanges && mode === MODE.UPDATE) || !regexOk}
                  className="btn-primary"
                >
                  {loading
                    ? 'Guardando...'
                    : mode === MODE.CREATE
                      ? 'Guardar en la BD'
                      : 'Actualizar'}
                </button>
              )}
              {!saveRegex && (
                <button
                  type="submit"
                  disabled={loading === true || !regexOk}
                  className="btn-primary"
                >
                  {'Solo insertar en XSD'}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModalRegex;
